function _assert_this_initialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _class_call_check(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _create_class(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _get_prototype_of(o) {
    _get_prototype_of = Object.setPrototypeOf ? Object.getPrototypeOf : function getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _get_prototype_of(o);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _set_prototype_of(subClass, superClass);
}
function _possible_constructor_return(self, call) {
    if (call && (_type_of(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assert_this_initialized(self);
}
function _set_prototype_of(o, p) {
    _set_prototype_of = Object.setPrototypeOf || function setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _set_prototype_of(o, p);
}
function _type_of(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
}
function _is_native_reflect_construct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _create_super(Derived) {
    var hasNativeReflectConstruct = _is_native_reflect_construct();
    return function _createSuperInternal() {
        var Super = _get_prototype_of(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _get_prototype_of(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return _possible_constructor_return(this, result);
    };
}
function _ts_generator(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { withSnackbar } from "notistack";
import React, { Component } from "react";
import { connect } from "react-redux";
import { closeConfirmation, getFullUserDetails, openConfirmation } from "@common/actions";
import CustomLoader from "@common/components/CustomLoader";
import Spinner from "@common/components/Spinner";
import { formatCardNumber, isMobile, isSafariBrowser } from "@common/services/helpers";
import request from "@common/services/request";
import { attachChargebeeButton, removeChargebeeButton } from "@common/utils/helpers";
import { KEY_ENTER, KEY_SPACE, PAYMENT_BRAINTREE, PAYMENT_BRAINTREE_ACCOUNT, PAYMENT_CARD, PAYMENT_TYPE_AMERCANEXPRESS, PAYMENT_TYPE_DISCOVERY, PAYMENT_TYPE_MASTERCARD, PAYMENT_TYPE_PAYPAL, PAYMENT_TYPE_VISA, SNACKBAR_AUTOHIDE_TIMEOUT, SNACKBAR_VARIANT_ERROR, SNACKBAR_VARIANT_SUCCESS } from "@config/constants";
import Button from "@material-ui/core/Button/Button";
var PaymentMethod = /*#__PURE__*/ function(Component) {
    "use strict";
    _inherits(PaymentMethod, Component);
    var _super = _create_super(PaymentMethod);
    function PaymentMethod(props) {
        _class_call_check(this, PaymentMethod);
        var _this;
        _this = _super.call(this, props);
        _this.state = {
            showDeleteLoading: false,
            showPaymentChangeLoading: false,
            paymentMethods: [
                PAYMENT_TYPE_MASTERCARD,
                PAYMENT_TYPE_VISA,
                PAYMENT_TYPE_DISCOVERY,
                PAYMENT_TYPE_AMERCANEXPRESS
            ]
        };
        _this.renderPayment = _this.renderPayment.bind(_assert_this_initialized(_this));
        _this.renderEmptyPayment = _this.renderEmptyPayment.bind(_assert_this_initialized(_this));
        _this.removePaymentMethod = _this.removePaymentMethod.bind(_assert_this_initialized(_this));
        _this.openChangePaymentPopup = _this.openChangePaymentPopup.bind(_assert_this_initialized(_this));
        _this.toggleFromKeyboard = _this.toggleFromKeyboard.bind(_assert_this_initialized(_this));
        _this.openConfirmation = _this.openConfirmation.bind(_assert_this_initialized(_this));
        return _this;
    }
    _create_class(PaymentMethod, [
        {
            /**
     * Render payment depending on the type
     * @return {ReactElement}
     */ key: "renderPayment",
            value: function renderPayment() {
                var _this_props = this.props, i18n = _this_props.i18n, paymentMethod = _this_props.paymentMethod;
                switch(paymentMethod.type){
                    case PAYMENT_CARD:
                        return /*#__PURE__*/ _jsxs("div", {
                            className: "row item",
                            children: [
                                /*#__PURE__*/ _jsx("div", {
                                    className: "type",
                                    children: /*#__PURE__*/ _jsx("img", {
                                        alt: paymentMethod.cardType,
                                        src: "/assets/media/card-".concat(paymentMethod.cardType, ".png"),
                                        onError: function(event) {
                                            event.target.src = "/assets/media/card-credit.svg";
                                        }
                                    })
                                }),
                                /*#__PURE__*/ _jsxs("div", {
                                    className: "column gap-8",
                                    children: [
                                        /*#__PURE__*/ _jsxs("div", {
                                            className: "column",
                                            children: [
                                                /*#__PURE__*/ _jsx("div", {
                                                    className: "label",
                                                    children: i18n.payment.numberLabel
                                                }),
                                                /*#__PURE__*/ _jsx("div", {
                                                    className: "content",
                                                    children: formatCardNumber(paymentMethod.maskedNumber)
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ _jsxs("div", {
                                            className: "column",
                                            children: [
                                                /*#__PURE__*/ _jsx("div", {
                                                    className: "label",
                                                    children: /*#__PURE__*/ _jsx("span", {
                                                        children: i18n.payment.dateLabel
                                                    })
                                                }),
                                                /*#__PURE__*/ _jsxs("span", {
                                                    className: "content",
                                                    children: [
                                                        paymentMethod.expiryMonth,
                                                        "/",
                                                        paymentMethod.expiryYear
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        });
                    case PAYMENT_TYPE_PAYPAL:
                        return /*#__PURE__*/ _jsxs("div", {
                            className: "row item",
                            children: [
                                /*#__PURE__*/ _jsx("div", {
                                    className: "type",
                                    children: /*#__PURE__*/ _jsx("img", {
                                        src: "/assets/media/paypal_logo.png",
                                        alt: PAYMENT_TYPE_PAYPAL
                                    })
                                }),
                                /*#__PURE__*/ _jsxs("div", {
                                    className: "column",
                                    children: [
                                        /*#__PURE__*/ _jsx("div", {
                                            className: "label",
                                            children: i18n.payment.paypalLabel
                                        }),
                                        /*#__PURE__*/ _jsx("div", {
                                            className: "content",
                                            children: paymentMethod.email
                                        })
                                    ]
                                })
                            ]
                        });
                    default:
                        return null;
                }
            }
        },
        {
            /**
     * Render empty payment info
     * @return {ReactElement}
     */ key: "renderEmptyPayment",
            value: function renderEmptyPayment() {
                return /*#__PURE__*/ _jsxs("div", {
                    className: "row item",
                    children: [
                        /*#__PURE__*/ _jsx("div", {
                            className: "type",
                            children: /*#__PURE__*/ _jsx("img", {
                                alt: "",
                                src: "common/assets/media/generic-card.svg"
                            })
                        }),
                        /*#__PURE__*/ _jsxs("div", {
                            className: "column",
                            children: [
                                /*#__PURE__*/ _jsx("div", {
                                    className: "empty-label",
                                    children: this.props.i18n.account.noPaymentMethod
                                }),
                                /*#__PURE__*/ _jsx("div", {
                                    className: "empty-content",
                                    children: this.props.i18n.account.emptyPayment
                                })
                            ]
                        })
                    ]
                });
            }
        },
        {
            key: "removePaymentMethod",
            value: /**
     * Delete payment method
     * @return {Promise<void>}
     */ function removePaymentMethod() {
                var _this = this;
                return _async_to_generator(function() {
                    var ajax, _this_props, i18n, enqueueSnackbar, error;
                    return _ts_generator(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _this.props.closeConfirmation();
                                ajax = request({
                                    method: "DELETE",
                                    url: "users/me/payment"
                                });
                                _this_props = _this.props, i18n = _this_props.i18n, enqueueSnackbar = _this_props.enqueueSnackbar;
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    4,
                                    ,
                                    5
                                ]);
                                _this.setState({
                                    showDeleteLoading: true
                                });
                                return [
                                    4,
                                    ajax
                                ];
                            case 2:
                                _state.sent();
                                sessionStorage.setItem("freshRemovePayment", true);
                                return [
                                    4,
                                    _this.props.getFullUserDetails()
                                ];
                            case 3:
                                _state.sent();
                                enqueueSnackbar(i18n.snackbar.removePaymentMethodSuccess, {
                                    variant: SNACKBAR_VARIANT_SUCCESS,
                                    autoHideDuration: SNACKBAR_AUTOHIDE_TIMEOUT
                                });
                                _this.setState({
                                    showDeleteLoading: false
                                });
                                return [
                                    3,
                                    5
                                ];
                            case 4:
                                error = _state.sent();
                                enqueueSnackbar(i18n.snackbar.removePaymentMethodFail, {
                                    variant: SNACKBAR_VARIANT_ERROR,
                                    autoHideDuration: SNACKBAR_AUTOHIDE_TIMEOUT
                                });
                                _this.setState({
                                    showDeleteLoading: false
                                });
                                console.error(error);
                                return [
                                    3,
                                    5
                                ];
                            case 5:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            /**
     * Open chargebee payment integration pop-up and check for new payment on closing it
     */ key: "openChangePaymentPopup",
            value: function openChangePaymentPopup() {
                var _this_props = this.props, i18n = _this_props.i18n, enqueueSnackbar = _this_props.enqueueSnackbar;
                if (typeof this.props.togglePaymentError === "function") {
                    this.props.togglePaymentError(false);
                }
                var _this = this;
                var onModalClose = function() {
                    var _ref = _async_to_generator(function() {
                        var data, error;
                        return _ts_generator(this, function(_state) {
                            switch(_state.label){
                                case 0:
                                    _state.trys.push([
                                        0,
                                        2,
                                        ,
                                        3
                                    ]);
                                    _this.setState({
                                        showPaymentChangeLoading: true
                                    });
                                    return [
                                        4,
                                        _this.props.getFullUserDetails()
                                    ];
                                case 1:
                                    data = _state.sent();
                                    _this.setState({
                                        showPaymentChangeLoading: false
                                    });
                                    if (Object.keys(data.paymentMethod).length > 0) {
                                        enqueueSnackbar(i18n.snackbar.editPaymentMethodSuccess, {
                                            variant: SNACKBAR_VARIANT_SUCCESS,
                                            autoHideDuration: SNACKBAR_AUTOHIDE_TIMEOUT
                                        });
                                    } else {
                                        enqueueSnackbar(i18n.snackbar.editPaymentMethodFail, {
                                            variant: SNACKBAR_VARIANT_ERROR,
                                            autoHideDuration: SNACKBAR_AUTOHIDE_TIMEOUT
                                        });
                                    }
                                    return [
                                        3,
                                        3
                                    ];
                                case 2:
                                    error = _state.sent();
                                    _this.setState({
                                        showPaymentChangeLoading: false
                                    });
                                    console.error(error);
                                    return [
                                        3,
                                        3
                                    ];
                                case 3:
                                    return [
                                        2
                                    ];
                            }
                        });
                    });
                    return function onModalClose() {
                        return _ref.apply(this, arguments);
                    };
                }();
                var onModalManualClose = function() {
                    chargebeeInstance.closeAll();
                    onModalClose();
                };
                var attachButton = function() {
                    return attachChargebeeButton(i18n.common.confirm, onModalManualClose);
                };
                // TODO: Refactor this, it is similar to the subscriptions/PaymentMethod.js
                var chargebeeInstance = Chargebee.getInstance();
                chargebeeInstance.openCheckout({
                    hostedPage: /*#__PURE__*/ _async_to_generator(function() {
                        var response;
                        return _ts_generator(this, function(_state) {
                            switch(_state.label){
                                case 0:
                                    return [
                                        4,
                                        request({
                                            method: "POST",
                                            url: "users/me/payment",
                                            data: {
                                                type: PAYMENT_BRAINTREE
                                            }
                                        }).catch(function(error) {
                                            console.error(error);
                                            enqueueSnackbar(i18n.snackbar.editPaymentMethodFail, {
                                                variant: SNACKBAR_VARIANT_ERROR,
                                                autoHideDuration: SNACKBAR_AUTOHIDE_TIMEOUT
                                            });
                                        })
                                    ];
                                case 1:
                                    response = _state.sent();
                                    return [
                                        2,
                                        response === null || response === void 0 ? void 0 : response.data
                                    ];
                            }
                        });
                    }),
                    loaded: function() {
                        if (!isMobile.any()) return;
                        attachButton();
                    },
                    step: function(step) {
                        if (!isMobile.any()) return;
                        switch(step){
                            case "portal_add_payment_method":
                            case "portal_edit_payment_method":
                                removeChargebeeButton();
                                break;
                            case "portal_view_payment_method":
                                attachButton();
                                break;
                        }
                    },
                    close: onModalClose
                });
            }
        },
        {
            /**
     *  Toggles the payment type form from keyboard
     *  @param {Object} event
     */ key: "toggleFromKeyboard",
            value: function toggleFromKeyboard(event) {
                var key = event.which;
                if (key === KEY_SPACE || key === KEY_ENTER) {
                    this.openChangePaymentPopup();
                }
            }
        },
        {
            /**
     * Opens confirmation modal for payment method deletion
     */ key: "openConfirmation",
            value: function openConfirmation() {
                var _subscription_;
                var _this_props = this.props, i18n = _this_props.i18n, _$openConfirmation = _this_props.openConfirmation, _$closeConfirmation = _this_props.closeConfirmation, userDetails = _this_props.userDetails;
                var subscription = userDetails.subscription, planDetails = userDetails.planDetails;
                var date = Date.now();
                var daysBeforeSubscriptionEnd = (((_subscription_ = subscription[0]) === null || _subscription_ === void 0 ? void 0 : _subscription_.currentTermEnd) - date / 1000) / (24 * 60 * 60);
                var message = daysBeforeSubscriptionEnd <= 5 && (planDetails === null || planDetails === void 0 ? void 0 : planDetails.isBasic) === false && (planDetails === null || planDetails === void 0 ? void 0 : planDetails.isPaid) && !(userDetails === null || userDetails === void 0 ? void 0 : userDetails.cf_bank_payment) ? i18n.account.areYouSureDeletePaymentNoDays : i18n.account.areYouSureDeletePayment;
                _$openConfirmation({
                    message: message,
                    declineMethod: _$closeConfirmation,
                    confirmMethod: this.removePaymentMethod
                });
            }
        },
        {
            key: "render",
            value: function render() {
                var _this = this;
                var _this_props = this.props, i18n = _this_props.i18n, isOrderPage = _this_props.isOrderPage, paymentMethod = _this_props.paymentMethod, hasPaymentError = _this_props.hasPaymentError, enqueueSnackbar = _this_props.enqueueSnackbar;
                var _this_state = this.state, showPaymentChangeLoading = _this_state.showPaymentChangeLoading, showDeleteLoading = _this_state.showDeleteLoading;
                var deleteButton = paymentMethod.length === 0 || isOrderPage ? null : /*#__PURE__*/ _jsx("div", {
                    className: "delete-wrapper",
                    onClick: this.openConfirmation,
                    onKeyDown: this.openConfirmation,
                    children: showDeleteLoading ? /*#__PURE__*/ _jsx(Spinner, {}) : /*#__PURE__*/ _jsxs(_Fragment, {
                        children: [
                            /*#__PURE__*/ _jsx("span", {
                                className: "icon icon-clear cancel-x pointer"
                            }),
                            /*#__PURE__*/ _jsx("div", {
                                className: "cancel-text",
                                children: i18n.account.clear
                            })
                        ]
                    })
                });
                if (hasPaymentError) {
                    enqueueSnackbar(i18n.errors.payment, {
                        variant: SNACKBAR_VARIANT_ERROR,
                        autoHideDuration: SNACKBAR_AUTOHIDE_TIMEOUT
                    });
                }
                return /*#__PURE__*/ _jsxs("div", {
                    className: "payment-card-wrapper",
                    children: [
                        /*#__PURE__*/ _jsxs("div", {
                            className: "payment-card",
                            children: [
                                showPaymentChangeLoading || showDeleteLoading ? /*#__PURE__*/ _jsx(CustomLoader, {
                                    i18n: i18n
                                }) : paymentMethod.length === 0 ? this.renderEmptyPayment() : this.renderPayment(),
                                deleteButton
                            ]
                        }),
                        /*#__PURE__*/ _jsx(Button, {
                            classes: {
                                label: "ux-button-label"
                            },
                            className: "button raised half-width pointer",
                            onKeyDown: function(event) {
                                return _this.toggleFromKeyboard(event, true);
                            },
                            onClick: this.openChangePaymentPopup,
                            children: /*#__PURE__*/ _jsx("span", {
                                children: paymentMethod.length === 0 ? i18n.button.addPaymentMethod : i18n.button.changePaymentMethod
                            })
                        })
                    ]
                });
            }
        },
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                /* Initialize a Chargebee instance after mounting the root component. */ this.chargebeeInstance = Chargebee.init({
                    site: PAYMENT_BRAINTREE_ACCOUNT
                });
            }
        }
    ]);
    return PaymentMethod;
}(Component);
var mapStateToProps = function(param) {
    var i18n = param.i18n, userDetails = param.userDetails;
    return {
        i18n: i18n,
        userDetails: userDetails
    };
};
export default withSnackbar(connect(mapStateToProps, {
    getFullUserDetails: getFullUserDetails,
    openConfirmation: openConfirmation,
    closeConfirmation: closeConfirmation
})(PaymentMethod));
